import React from 'react';
import { theme } from 'antd';

import { PointInTime } from '~components/PointInTime';
import { CustomTooltip } from '~components/Tooltip';

import { NO_VALUE, NOT_PROXIED_TOOLTIP } from './PagesFormatting';

export type PagesLastCrawledValueProps = {
  lastCrawledAt: string | null;
  lastStatusCode: number | null;
};

/**
 * Last Crawled value shared by the Pages table column and the inspect drawer.
 * No crawl in the window and a cached URL Googlebot has not requested in the
 * period both render `—`; only the tooltip tells them apart.
 */
function PagesLastCrawledValue({ lastCrawledAt, lastStatusCode }: PagesLastCrawledValueProps) {
  const { token } = theme.useToken();

  if (lastStatusCode === null) {
    return (
      <CustomTooltip placement="top" message={NOT_PROXIED_TOOLTIP}>
        <span style={{ color: token.colorTextTertiary }}>{NO_VALUE}</span>
      </CustomTooltip>
    );
  }

  if (lastCrawledAt === null) return <>{NO_VALUE}</>;

  return <PointInTime value={lastCrawledAt} />;
}

export default PagesLastCrawledValue;
